<template>
	<vue-select
		@search="searchContents"
		:filterable="false"
		v-model="model"
		:options="filtered"
		name="internet_shop"
		v-validate="'required'"
		multiple
		label="title"
    :loading="loading"
	>
	</vue-select>
</template>

<script>
import { debounce as _debounce } from 'lodash-es';

export default {
  name: 'ShopSelectDropdown',
  props: ['shopType', 'value', 'setShopDropdownValue'],
  data() {
    return {
      observer: null,
      limit: 10,
      page: 1,
      loading: false,
      keyword: '',
    };
  },
  mounted() {
  },
  computed: {
    internetShopType() {
      return this.shopType === 'internetShop';
    },
    filtered() {
      const type = this.shopType === 'internetShop' ? 'internetShops' : 'phoneShops';
      const search = this.keyword.toLowerCase();

      if (type === 'internetShops') {
        return this.internetShops;
      }

      return this.phoneShops;
    },
    internetShops() {
      return this.$store.state.groupShops.internetShops;
    },
    phoneShops() {
      return this.$store.state.groupShops.phoneShops;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        const type = this.internetShopType ? 'internet_shops' : 'phone_shops';
        this.setShopDropdownValue(type, value);
      },
    },
  },
  methods: {
    searchContents: _debounce(function (keyword) {
      this.keyword = keyword;
      this.getContent();
    }, 500),
    async getContent() {
      const urlType = this.internetShopType ? 'internet-shops' : 'phone-shops';
      const dispatchType = this.internetShopType ? 'setInternetShops' : 'setPhoneShops';

      this.loading = true;

      await this.$http
        .get(`/secret-shop-management/${urlType}?page=1`, {
          params: {
            search: this.keyword,
            type: ['Active'],
            perPage: 20,
            isGroupShop: true,
          },
        })
        .then(({ data }) => {
          this.$store.dispatch(`groupShops/${dispatchType}`, data.data);
          this.loading = false;
          console.log(this.loading);
        })
        .catch(() => {
          this.$notify(
            'error',
            'Error when loading the data. Please refresh the page and try again.',
          );
          this.loading = false;
        });
    },
    async getData() {
      const urlType = this.internetShopType ? 'internet-shops' : 'phone-shops';
      const dispatchType = this.internetShopType ? 'setInternetShops' : 'setPhoneShops';

      this.loading = true;

      await this.$http
        .get(`/secret-shop-management/${urlType}?page=${this.page}`, {
          params: {
            search: this.keyword,
            type: ['Active'],
            perPage: 20,
            isGroupShop: true,
          },
        })
        .then(({ data }) => {
          this.$store.dispatch(`groupShops/${dispatchType}`, data.data);
          this.loading = false;
          console.log(this.loading);
        })
        .catch(() => {
          this.$notify(
            'error',
            'Error when loading the data. Please refresh the page and try again.',
          );

          this.loading = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped></style>
